
<template>
  <transition name="alert-fade">
    <div class="root-toast" v-show="visible">
      <div id="toast" :class="[showLogo ? 'dialog-logo-tips':'dialog-tips']">
        <img :src="logoPic" v-show="showLogo" />
        <p v-html="message"></p>
      </div>
    </div>

  </transition>
</template>
<script>
export default {
  data () {
    return {
      visible: false,
      message: '',
      showLogo: false, // 是否显示带logo的提示窗
      logoPic: '', // logo图片
      timer: null
    }
  },
  methods: {
    show (msg, duration = 1000, callback) {
      this.showLogo = false
      this.message = msg
      this.visible = true
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        this.visible = false
        // this.message = ''
        callback && callback()
      }, duration)
    },
    success (msg, duration = 1000, callback) {
      weui.toast(msg, {
        duration: duration,
        callback: () => {
          callback && callback()
        }
      })
    },
    fail (msg, duration = 1000, callback) {
      weui.toast(msg, {
        className: 'sc-toast-fail',
        duration: duration,
        callback: () => {
          callback && callback()
        }
      })
    },
    // sync (msg, duration) {
    //   this.logoPic = '../../../../static/images/icon_toast_sync@2x.png'
    //   this.logoShow(msg, duration)
    // },
    exception (msg, duration = 1000, callback) {
      weui.toast(msg, {
        className: 'sc-toast-exception',
        duration: duration,
        callback: () => {
          callback && callback()
        }
      })
    },
    // logoShow (msg, duration = 1000, callback) {
    //   this.visible = true
    //   this.showLogo = true
    //   this.message = msg
    //   if (this.timer) {
    //     clearTimeout(this.timer)
    //   }
    //   this.timer = setTimeout(() => {
    //     this.visible = false
    //     callback && callback()
    //   }, duration)
    // }

  }
}
</script>
<style lang="scss" scoped>
.alert-fade-enter-active,
.alert-fade-leave-active {
  transition: opacity 0.3s;
}
.alert-fade-enter,
.alert-fade-leave-to {
  opacity: 0;
}

.root-toast {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
}
.dialog-tips {
  min-width: 1.82rem;
  min-height: 0.8rem;
  max-width: 6.4rem;
  // word-break: break-all;
  // white-space: normal;
  padding: 0.22rem 0.37rem;
  border-radius: 0.25rem;
  background: rgba(0, 0, 0, 0.6);
  text-align: center;
  font-size: 0.28rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(230, 230, 230, 1);
  line-height: 0.54rem;
}

.dialog-logo-tips {
  position: fixed;
  z-index: 100;
  // min-width: 1.82rem;
  // min-height: 0.8rem;
  padding: 0.46rem 0.6rem;
  border-radius: 0.25rem;
  white-space: pre-wrap;
  background: rgba(0, 0, 0, 0.7);
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 0.28rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(230, 230, 230, 1);
  line-height: 0.37rem;

  img {
    width: 0.66rem;
    height: 0.66rem;
  }
  p {
    padding-top: 0.25rem;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/include/toast/toast.vue